/**
 * TOGGLE BUTTON TOKENS
 */
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createToggleButtonTokens(s: SemanticTokens) {
  return {
    base: {
      padding: s.layout.padding.xs, // --toggle-button-base-padding
      radius: s.radius.md, // --toggle-button-base-radius
      gap: s.layout.gap.xs, // --toggle-button-base-gap
      fontWeight: s.typography.fontWeight.normal, // --toggle-button-base-font-weight
      size: s.controlSize.md, // --toggle-button-base-size (2.75rem)
    },
    icon: {
      size: s.iconSizes.lg, // --toggle-button-icon-size
    },
    content: {
      size: s.iconSizes.lg, // --toggle-button-content-size
    },
    bg: 'transparent', // --toggle-button-bg: transparent
    bgHover: s.interactive.primary.subtle, // --toggle-button-bg-hover
    bgChecked: s.interactive.primary.subtle, // --toggle-button-bg-checked
    fg: s.text.secondary, // --toggle-button-fg: var(--text-secondary)
    fgHover: s.text.primary, // --toggle-button-fg-hover: var(--text-primary)
    fgChecked: s.text.primary, // --toggle-button-fg-checked: var(--text-primary)
    iconFg: s.text.secondary, // --toggle-button-icon-fg
    iconFgHover: s.text.primary, // --toggle-button-icon-fg-hover
    iconFgChecked: s.text.primary, // --toggle-button-icon-fg-checked
    bgDisabled: s.surface.disabled, // --toggle-button-bg-disabled
    fgDisabled: s.text.disabled, // --toggle-button-fg-disabled
    iconFgDisabled: s.text.muted, // --toggle-button-icon-fg-disabled
    borderInvalid: s.text.danger, // --toggle-button-border-invalid
  };
}
export const toggleButtonTokens = createToggleButtonTokens(SEMANTIC);
